import React from 'react';
import { useTranslation } from 'react-i18next';

const DateRangeSelector = ({ selectedRange, onRangeChange }) => {
  const { t } = useTranslation();

  const dateRanges = [
    { key: 'today', label: t('Today') },
    { key: 'week', label: t('Last Week') },
    { key: 'month', label: t('Last Month') },
    { key: 'quarter', label: t('Last Quarter') },
    { key: 'year', label: t('Last Year') },
    { key: 'all', label: t('All') }
  ];

  return (
    <div className="date-range-selector">
      {dateRanges.map(range => (
        <button
          key={range.key}
          className={`date-range-tab ${selectedRange === range.key ? 'active' : ''}`}
          onClick={() => onRangeChange(range.key)}
        >
          {range.label}
        </button>
      ))}
    </div>
  );
};

export default DateRangeSelector;